<input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" [(ngModel)]="filterValue" (ngModelChange)="onValueChange($event)">
